module.exports = __webpack_public_path__ + "img/gift1-tablet.0179dea6.png";